import { config } from '../config';

const errorMessage = '[apiPayment] error to method';

export const apiPayment = {
  list: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.PAYMENT.LIST);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'list', error);
      throw error;
    }
  },
  createOrder: async (axiosPrivate, productId) => {
    try {
      const response = await axiosPrivate.post(config.API.PAYMENT.CREATE_ORDER(productId));
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'createOrder', error);
      throw error;
    }
  },
  createInvoice: async (axiosPrivate, productId) => {
    try {
      const response = await axiosPrivate.post(config.API.PAYMENT.CREATE_INVOICE(productId));
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'createInvoice', error);
      throw error;
    }
  },
  createBindCard: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.post(config.API.PAYMENT.CREATE_BIND_CARD);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'createBindCard', error);
      throw error;
    }
  },
  unBindCard: async (axiosPrivate, paymentId) => {
    try {
      const response = await axiosPrivate.post(config.API.PAYMENT.UNBIND_CARD(paymentId));
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'unBindCard', error);
      throw error;
    }
  },
  unBindAllCards: async (axiosPrivate) => {
    try {
      const resolvedPayments = (await apiPayment.list(axiosPrivate)).items || [];
      const paymentIds = [...new Set(resolvedPayments.map((payment) => payment?._id).filter(Boolean))];

      for (const paymentId of paymentIds) {
        await apiPayment.unBindCard(axiosPrivate, paymentId);
      }

      return {
        total: paymentIds.length,
      };
    } catch (error) {
      console.error(errorMessage + 'unBindAllCards', error);
      throw error;
    }
  },
};
